import { INTERNALFlag, useINTERNALFlag, PropsNoName } from '@components/Flag';
/**  */
export const useFlagappAllowDebug = (): boolean => useINTERNALFlag('app-allow-debug');
/**  */
export const FlagappAllowDebug = (props: PropsNoName) => <INTERNALFlag name="app-allow-debug" {...props}/>
